import React from 'react';
import { IconTypes } from '@eika/icon';

import LabelTypes from './LabelTypes';
import LabelProps from './Props';
import Label from './Label';

interface ErrorLabelProps extends LabelProps {
    icon?: IconTypes;
    type?: LabelTypes.ERROR | LabelTypes.ERROR_SMALL;
}

const ErrorLabel = ({ id, text, className, icon, type = LabelTypes.ERROR, ...rest }: ErrorLabelProps): JSX.Element => {
    return <Label id={id} text={text} type={type} icon={icon} className={className} role="alert" {...rest} />;
};

export default ErrorLabel;
